import { render } from "./MyBookings.vue?vue&type=template&id=b6244d26"
import script from "./MyBookings.vue?vue&type=script&lang=js"
export * from "./MyBookings.vue?vue&type=script&lang=js"
script.render = render

export default script